import React from 'react';
import './About.css';

const AboutUs = () => {
  return (
    <section className="about-page">
      <div className="about-container">
        <h1>About Revora</h1>
        <p className="about-tagline">
          Where engineering meets emotion. Crafting luxury on wheels for those who drive dreams.
        </p>

        <div className="about-sections">
          <div className="about-box">
            <h2>Our Story</h2>
            <p>
              Revora was created with one vision — to unite innovation, craftsmanship, and passion
              for performance. We bring together the world’s most iconic luxury car brands in one
              immersive platform, where elegance meets engineering precision.
            </p>
          </div>

          <div className="about-box">
            <h2>Our Mission</h2>
            <p>
              We aim to redefine automotive exploration by offering a seamless experience that blends
              technology with artistry. Every vehicle featured on Revora stands as a symbol of excellence,
              precision, and unmatched design.
            </p>
          </div>

          <div className="about-box">
            <h2>Why Choose Revora</h2>
            <div className="about-highlights">
              <div className="highlight-card">
                <h3>Authentic Models</h3>
                <p>Verified information and design precision from official manufacturers.</p>
              </div>
              <div className="highlight-card">
                <h3>Luxury Experience</h3>
                <p>Explore brands in a premium interface designed for sophistication.</p>
              </div>
              <div className="highlight-card">
                <h3>Advanced Configurator</h3>
                <p>Customize, visualize, and configure your dream car effortlessly.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
